import NicknameBar from '../components/NicknameBar';
import TeamBadge from '../components/TeamBadge';

type TeamColor = 'BLUE' | 'RED' | 'GREEN' | 'YELLOW';

interface BondWinnerScreenProps {
  voteId: string;
  fromTeam: TeamColor;
  heroName: string;
  heroImageUrl?: string;
  bondText: string;
}

function BondWinnerScreen({ fromTeam, heroName, heroImageUrl, bondText }: BondWinnerScreenProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 pt-10">
      <NicknameBar />
      {/* Hero Image */}
      {heroImageUrl && (
        <div className="mb-6">
          <img
            src={heroImageUrl}
            alt={heroName}
            className="w-40 h-40 object-cover rounded-xl border-4 border-parchment-300 shadow-2xl"
          />
        </div>
      )}

      {/* Hero Name */}
      <h1 className="text-3xl font-heading font-bold text-ink mb-2 text-center">
        {heroName}
      </h1>

      {/* Team */}
      <div className="mb-6">
        <TeamBadge teamColor={fromTeam} size="md" />
      </div>

      {/* Bond Text */}
      <div className="parchment-card p-6 border border-team-yellow max-w-sm">
        <p className="text-2xl text-team-yellow text-center italic">
          "{bondText}"
        </p>
      </div>
    </div>
  );
}

export default BondWinnerScreen;
